import React from 'react';
import { Box, Typography, Divider, Grid, Paper } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledPaper = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(3),
  borderRadius: 12,
  boxShadow: theme.shadows[3],
  backgroundColor: theme.palette.background.paper,
}));

const DetailItem = ({ label, value }) => (
  <Grid item xs={12} sm={6} md={4}>
    <Typography variant="subtitle1" gutterBottom>
      <Box component="span" sx={{ 
        fontWeight: 'bold', 
        color: 'text.secondary',
        minWidth: 120,
        display: 'inline-block'
      }}>
        {label}:
      </Box>
      <Box component="span" sx={{ ml: 1, color: 'text.primary' }}>
        {value || '-'}
      </Box>
    </Typography>
  </Grid>
);

const DetalleRendicion = ({ row }) => {
  return (
    <Box sx={{ p: 2 }}>
      <StyledPaper>
        <Typography variant="h6" gutterBottom sx={{ 
          mb: 2,
          color: 'primary.main',
          display: 'flex',
          alignItems: 'center'
        }}>
          Detalles de la Rendición {row.hoja_ruta != null?("- Hoja de Ruta " +row.nombre_hoja):null}
        </Typography>
        
        <Divider sx={{ mb: 3 }} />
        
        <Grid container spacing={2}>
          <DetailItem label="Remito" value={row.nro_rendicion} />
          <DetailItem label="Fecha" value={row.fecha} />
          <DetailItem label="KM Inicial" value={row.km_inicial} />
          <DetailItem label="KM Final" value={row.km_final} />
          <DetailItem label="Hora Salida" value={row.hora_salida} />
          <DetailItem label="Hora Entrada" value={row.hora_entrada} />
        </Grid>
      </StyledPaper>
    </Box>
  );
};

export default DetalleRendicion;